module.exports = function ($) {
    return {
        init: function () {
            var self = this;
            var body = $("body");
            var searchBar = $(".searchBar");

            // Sticky Search Bar
            $(document).scroll(function () {
                if (!body.hasClass("search") && searchBar.length > 0) {
                    if (body.scrollTop() > searchBar.outerHeight(true)) {
                        body.addClass("stickySearchBar");
                    } else {
                        body.removeClass("stickySearchBar");
                    }
                }
            });

            // Set focus to search bar if on page, otherwise load search page
            $("nav .search a.searchBar__link").click(function (e) {
                e.preventDefault();
                var searchField = $('.searchBar__keywords input:visible, .homeHero__keywords input:visible');
                if (searchField.length > 0) {
                    body.animate({ scrollTop: 0 }, 500, function () {
                        //Set the focus to the search bar
                        searchField.eq(0).focus();
                    });
                } else {
                  //  window.location = "/search";
                }
            });

            // Bind enter/submit for search fields
            $('.searchBar__keywords input, .searchBar__categories select, .homeHero__searchBar input, .homeHero__searchBar select, .collectionSearch__searchBar select, .collectionSearch__searchBar input').keypress(function (e) {
                if (e.which == 13) {
                    self.submitSearch(this);
                    return false;
                }
            });

            // Bind the search submissions
            $('.searchBar__search a, .homeHero__search a, .collectionSearch__search a').click(function (e) {
                e.preventDefault();
                self.submitSearch(this);
            });

            // Search from the header.
            $('.nav__siteSearch a.searchBtn').click(function (e) {
                e.preventDefault();
                var keywords = $(this).prev('input').val();
                if (keywords.length > 0) {
                    window.location.href = "/search?keywords=" + encodeURI(keywords);
                }
            });

            $('.nav__siteSearch input').keypress(function (e) {
                if (e.which == 13) {
                    var keywords = $(this).val();
                    if (keywords.length > 0) {
                        window.location.href = "/search?keywords=" + encodeURI(keywords);
                    }
                }
            });


            $('.searchBar__link').on('click touchstart', function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
                if ($(this).hasClass('active')) {
                    // Set all children to show.
                    $('.searchBar__container').find('.searchBar__keywords, .searchBar__categories, .searchBar__search').each(function () {
                        $(this).toggle();
                    }).promise().done($('.searchBar__container').slideDown());
                }
                else {
                    $('.searchBar__container').slideUp();
                    $('.searchBar__container').find('.searchBar__keywords, .searchBar__categories, .searchBar__search').each(function () {
                        $(this).toggle();
                    });
                    
                }
            });

            $('.generalSearchBar__link').on('click touchstart', function (e) {
                e.preventDefault();
                $(this).toggleClass('active');
                if ($(this).hasClass('active')) {
                    // Set all children to show.
                    $('.generalSearchBar__container').find('.generalSearchBar__keywords, .generalSearchBar__websites, .searchBar__search').each(function () {
                        $(this).toggle();
                    }).promise().done($('.generalSearchBar__container').slideDown());
                }
                else {
                    $('.generalSearchBar__container').slideUp();
                    $('.generalSearchBar__container').find('.generalSearchBar__keywords, .generalSearchBar__websites, .generalSearchBar__search').each(function () {
                        $(this).toggle();
                    });

                }

            });

        },
        submitSearch: function (source) {
            var section = $(source).parents("section");
            var keywords = $("input", section);
            var filter = 'collection';
            var filterVal = $("select", section);
            var url = $(source).attr('href');
            console.log(url);
            var searchUrl = url ? url : "/search";
            
            if (keywords.length > 0 || filterVal.length > 0) {
                window.location.href = searchUrl + "?keywords=" + encodeURI(keywords.val()) + "&" + filter + "=" + encodeURI(filterVal.val());
            }
        }
    }
}